import resilienceConsultationClient from '@/axiosClients/resilienceConsultationClient';

const rescheduleResilienceConsultation = (consultationId, data) => {
  return resilienceConsultationClient.put(`/consultation/reschedule/${consultationId}`, data);
};

const approveAdditionalSessionRequest = (requestId, payload = {}) => {
  return resilienceConsultationClient.post(`/admin/additional-session-requests/${requestId}/approve`, payload);
};

const rejectAdditionalSessionRequest = (requestId, payload = {}) => {
  return resilienceConsultationClient.post(`/admin/additional-session-requests/${requestId}/reject`, payload);
};

/** POST …/consultation/confirm — agenda admin Resiliencia (base: VUE_APP_RESILIENCE_CONSULTATION_URL) */
const confirmResilienceConsultation = (payload) => {
  return resilienceConsultationClient.post('/consultation/confirm', payload);
};

const getAdminAdditionalSessions = (userId) => {
  return resilienceConsultationClient.get(`/admin/users/${userId}/additional-sessions`);
};

const updateAdminAdditionalSessions = (userId, payload) => {
  return resilienceConsultationClient.patch(`/admin/users/${userId}/additional-sessions`, payload);
};

const getPendingTestimonialSubmissions = () => {
  return resilienceConsultationClient.get('/admin/testimonial-submissions');
};

const getPendingTestimonialSubmissionForUser = (userId) => {
  return resilienceConsultationClient.get(`/admin/users/${userId}/testimonial-submission`);
};

const approveTestimonialSubmission = (submissionId) => {
  return resilienceConsultationClient.post(`/admin/testimonial-submissions/${submissionId}/approve`);
};

const rejectTestimonialSubmission = (submissionId, payload = {}) => {
  return resilienceConsultationClient.post(`/admin/testimonial-submissions/${submissionId}/reject`, payload);
};

export default {
  rescheduleResilienceConsultation,
  approveAdditionalSessionRequest,
  rejectAdditionalSessionRequest,
  confirmResilienceConsultation,
  getAdminAdditionalSessions,
  updateAdminAdditionalSessions,
  getPendingTestimonialSubmissions,
  getPendingTestimonialSubmissionForUser,
  approveTestimonialSubmission,
  rejectTestimonialSubmission,
};

